import { Row, Col } from 'react-bootstrap';
import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLoaderData, useParams } from "react-router-dom"; // get value from router loader.

import { loadGuiBootstarp, loadOrgBootstarp, loadTargetSite } from "../../stores/slice/fetchStatus";

import Button from "components/Button";
import Input from 'components/Input';
import DropdownWithItem from "components/DropdownWithItem";

import useCountry from "hooks/useCountry";

import { isNil, cloneDeep, orderBy } from "lodash";

const Dashboard = () => {
  const dispatch = useDispatch();
  console.log('Dashboard ', useSelector(state => state));
  const loaderData = useLoaderData();
  const { id } = useParams();
  const fetchStatus = useSelector(state => state.fetchStatus);
  const pageContext = useSelector(state => state.pageContext);
  const { countryList, selectedCountry, changeCountry, changeCity, setDefaultCountry } = useCountry();

  const [forTest, setForTest] = useState({ targetSite: '' });

  const reloadGuiBootstarp = () => {
    console.log('Dashboard Bootstarp reload start~~');
    dispatch(loadGuiBootstarp());
  };

  const reloadOrgBootstarp = (loadGui) => {
    console.log('Dashboard ORG Bootstarp reload start~~');
    if (loadGui) {
      dispatch(loadOrgBootstarp(pageContext.selectedOrg.id, true));
    } else {
      dispatch(loadOrgBootstarp(pageContext.selectedOrg.id));
    }
  };

  const loadSite = () => {
    const id = forTest.targetSite.length === 0 ? null : parseInt(forTest.targetSite);
    // 1. If add type can change to site or tag.ex: { type: organizationType.tag, id: 123; }
    // 2. null is change to ORG level. ex: {id: null}
    dispatch(loadTargetSite({ id }));
  };

  // useEffect(() => {
  //   if(!isNil(fetchStatus.reloadStatus.timestamp)){
  //     console.log('Dashboard Bootstarp reload completed~~ : etchStatus.reloadStatus.timestamp')
  //   }
  // }, [fetchStatus.reloadStatus.timestamp]);
  useEffect(() => {
    console.log('fetchStatus.reloadStatus.timestamp', fetchStatus?.reloadStatus);
  }, [fetchStatus?.reloadStatus]);


  useEffect(() => {
    if (!isNil(pageContext)) {
      console.log('Dashboard Bootstarp reload completed~~: pageContext');
    }

  }, [pageContext]);

  return (
    <>
      <div className="layout-container layout-container--fluid">
        Dashboard <br />
        <Button
          label='Test reload gui Bootstarp'
          className=''
          onClick={() => reloadGuiBootstarp()}
        ></Button>
        <Button
          label='&uarr;&uarr;&uarr;Test reload ORG Bootstarp(select org)'
          className=''
          onClick={() => reloadOrgBootstarp()}
        ></Button>

        <Button
          label='&uarr;&uarr;&uarr;Test reload gui & ORG Bootstarp(select org)'
          className=''
          onClick={() => reloadOrgBootstarp(true)}
        ></Button>

        <br /><br /><br />
        <div className="modal-form-field">
          <div className='form-title'>site id:</div>
          <div className='form-field'>
            <Input
              style={{
                width: '200px',
              }}
              type="number"
              placeholder='Empty is change to ORG'
              value={forTest.targetSite}
              onChange={e => setForTest({ ...forTest, targetSite: e.target.value })} />
            <Button
              label='load taget site'
              className=''
              onClick={() => loadSite()}
            ></Button>
          </div>
        </div>
        <br />
        <>
          <Row className="mb-5">
            <Col md="4">
              <div>change country</div>
              <div className="dropdown normal">
                <DropdownWithItem
                  id="lang-dropdown"
                  extendClassName="btn-dropdown-no-border"
                  selectedItem={selectedCountry?.country || {}}
                  itemList={countryList?.country || []}
                  onClick={(item) => { changeCountry(item) }}
                />
              </div>
            </Col>
            <Col md="4">
              <div>change city</div>
              <div className="dropdown rwd">
                <DropdownWithItem
                  id="lang-dropdown"
                  extendClassName="btn-dropdown-no-border"
                  selectedItem={selectedCountry?.city || {}}
                  itemList={countryList?.city || []}
                  onClick={(item) => { changeCity(item) }}
                />
              </div>
            </Col>
            <Col md="4">
              <div>set default Taiwan</div>
              <Button
                label='set default country Taiwan'
                className=''
                onClick={() => {
                  setDefaultCountry({ country: { title: 'Taiwan' } })
                  // or setDefaultCountry({ country: { title: 'Taiwan' }, city: { title: 'Taipei' } })
                  // or setDefaultCountry({})
                }}
              ></Button>
            </Col>
          </Row>
        </>


      </div>
    </>
  );
};

export default Dashboard;